import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { BackupsService } from "@app/services/backups.service";
import { Observable, Subject } from "rxjs";
import {
  distinctUntilChanged,
  distinctUntilKeyChanged,
  take,
  takeUntil,
} from "rxjs/operators";
import { AffiliatesListModel } from "../../../models/SearchAffiliate.model";
import {
  TransactionsToBackupResponse,
  TransactionsToBackUpResponseModel,
} from "../../../models/TransactionsToBackupResponse";
import Swal from "sweetalert2";
import * as moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { PaginationComponent } from "@app/components/layout/pagination/pagination.component";
import { TransactionsToBackUpRequestModel } from "../../../models/TransactionsToBackupModel";
import {
  CreateBackingsRequest,
  CreateBackingsRequestModel,
} from "../../../models/CreateBackings.model";
import { CreateBackingsResponse } from "../../../models/CreateBackingsResponse.model";
import { HelperService } from "@app/services/helper.service";
import { SelectsService } from "@services/selects.service";
import { BackupsTableHeadersService } from "@app/services/backups-table-headers.service";
import { ModalService } from "@app/services/modal.service";
import { SearchAutocompleteAffiliateComponent } from "../search-autocomplete-affiliate/search-autocomplete-affiliate.component";
import { BackupsStoreService } from "@app/services/backups-store.service";
import { SubjectService } from "@app/services/subject.service";

@Component({
  selector: "app-filing-table",
  templateUrl: "./filing-table.component.html",
  styleUrls: ["./filing-table.component.scss"],
})
export class FilingTableComponent implements OnInit, OnDestroy {
  @ViewChild("paginationComponent") paginationComponent: PaginationComponent;
  @ViewChild("searchAutocompleteAffiliate")
  searchAutocompleteAffiliate: SearchAutocompleteAffiliateComponent;

  public finalDateInput: Date;
  public finalDate: any;
  public initDate: any;
  public cantPages = 0;
  public currentPage = 1;
  public counterRequest: number = 0;
  public activeTab: string = "";
  public parentTab: string = "settlement-table";
  public showModalOnError: boolean = false;

  public documentTypesOptions = [
    {
      LABEL: "CEDULA DE CIUDADANIA",
      ID: "C",
      VALUE: "C.C CEDULA DE CIUDADANIA",
    },
    {
      LABEL: "NÚMERO IDENFICACIÓN TRIBUTARIA",
      ID: "N",
      VALUE: "NIT NÚMERO IDENFICACIÓN TRIBUTARIA",
    },
    {
      LABEL: "CEDULA DE EXTRANJERIA",
      ID: "E",
      VALUE: "C.E. CÉDULA DE EXTRANJERIA",
    },
  ];

  public stateShowSearchResult$: Observable<boolean> =
    this.backupsStore.stateShowSearchResult$;
  public transactionsToBackup: TransactionsToBackUpResponseModel[] = [];
  public selectedItemsSettlement: CreateBackingsRequestModel[] = [];
  public createBackingRequest: CreateBackingsRequest =
    new CreateBackingsRequest();
  public search: TransactionsToBackUpRequestModel =
    new TransactionsToBackUpRequestModel();
  private readonly unsubscribe$: Subject<void> = new Subject<void>();

  public dataUserLoged: any;

  constructor(
    private backupsService: BackupsService,
    private backupsStore: BackupsStoreService,
    private spinner: NgxSpinnerService,
    public helper: HelperService,
    public selects: SelectsService,
    public tableHeaders: BackupsTableHeadersService,
    public modal: ModalService,
    public subject: SubjectService
  ) {
    this.dataUserLoged = JSON.parse(sessionStorage.getItem('user')).userInfo;
  }

  ngOnInit() {
    this.subject.headerCollapse(true);
    // this.modal.show('settlementResponse', { title: 'Respuesta de radicación' });
    this.initilizeDateRangePicker();
    this.getTransactionsToBackUp(1);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.subject.headerCollapse(false);
  }

  goToPage({ currentPage }) {
    this.currentPage = currentPage;
    this.getTransactionsToBackUp(currentPage);
  }

  initAffiliate(stateAffiliate: AffiliatesListModel) {
    const instanceModel = new TransactionsToBackUpRequestModel();
    this.search = {
      ...this.helper.assignEnumerableKeysAndAssignDefaultValues(
        stateAffiliate,
        instanceModel
      ),
      initialDate: this.search.initialDate,
      finalDate: this.search.finalDate,
    };
    console.log("this.search setlement", this.search);
    // this.initilizeDateRangePicker();
    //  Si recibe el document vacio no ejecuta una nueva búsqueda
    if (
      this.activeTab === this.parentTab &&
      (this.search.affiliateDocument !== "0" ||
        this.search.issuerDocument !== "0")
    ) {
      this.showModalOnError = false;
      this.getTransactionsToBackUp(1);
    }
  }

  onSearch(textSearch: string) {
    console.log("textSearch", textSearch);
    // this.search.search = textSearch;
    this.getTransactionsToBackUp(1);
  }

  onDateRange([startDate, endDate]) {
    console.log("textSearch", "asdasdasdasdasd");
    this.search.initialDate = moment(startDate)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .format("YYYY-MM-DD HH:mm:ss");

    this.search.finalDate = moment(endDate)
      .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
      .format("YYYY-MM-DD HH:mm:ss");

    if (!this.validateAffiliate()) return;

    this.getTransactionsToBackUp(1);
  }

  getTransactionsToBackUp(currentPage: number): void {
    this.spinner.show();
    this.counterRequest++;
    this.search.currentPage = currentPage;
    this.search.affiliateDocumentType = this.dataUserLoged.TIPO_DOCUMENTO;
    this.search.affiliateDocument = this.dataUserLoged.DOCUMENTO;

    this.backupsService.getTransactionsToBackUp(this.search).subscribe(
      (transactionsToBackUp: TransactionsToBackupResponse) => {
        if (transactionsToBackUp && transactionsToBackUp.ok === false) {
          this.handleGetTransactionsToBackUpError();
          return;
        }
        this.transactionsToBackup = transactionsToBackUp["data"];
        this.cantPages = transactionsToBackUp["totalPages"];
        this.selectedItemsSettlement = [];
        this.spinner.hide();
        if (this.searchAutocompleteAffiliate)
          this.searchAutocompleteAffiliate.toggleResults(false);
        console.log("transactions to backup ->", transactionsToBackUp);
      },
      (error: any) => {
        this.handleGetTransactionsToBackUpError(error);
      }
    );
  }

  checkedItemsSettlement(
    transactionSelected: TransactionsToBackUpResponseModel
  ) {
    const { affiliateDocumentType: documentType, affiliateDocument: document } =
      transactionSelected;

    // this.createBackingRequest.affiliateDocumentType = documentType;
    // this.createBackingRequest.affiliateDocument = document;

    this.selectedItemsSettlement = this.transactionsToBackup.filter(
      (transaction: TransactionsToBackUpResponseModel, idx) =>
        transaction["check"] === true
    );
    this.createBackingRequest.transactionsToBackUp =
      this.selectedItemsSettlement.map(
        (transaction: TransactionsToBackUpResponseModel) =>
          this.convertItemToBackingRequest(transaction)
      );
  }

  convertItemToBackingRequest(
    transactionSelected: TransactionsToBackUpResponseModel
  ): CreateBackingsRequestModel {
    let createBackingsRequest: CreateBackingsRequestModel =
      new CreateBackingsRequestModel();
    for (const key of Object.keys(transactionSelected)) {
      if (key in createBackingsRequest) {
        createBackingsRequest[key] = transactionSelected[key];
      }
    }
    return createBackingsRequest;
  }

  showModalSecondEmail() {
    this.modal.show('filingClaimsEmail');
  }

  createBacking(email?:string) {
    
    this.spinner.show();
    this.createBackingRequest.transactionsToBackUp.forEach((transaction:CreateBackingsRequestModel) => transaction.email = email);
    this.createBackingRequest.user = this.dataUserLoged.USUARIO;

    this.backupsService.createBacking(this.createBackingRequest).subscribe(
      (createBackingResponse: CreateBackingsResponse) => {
        if (createBackingResponse && createBackingResponse["ok"] === false) {
          this.handleCreateBackingError();
          return;
        }
        // console.log("create backing ->", createBackingResponse);
        this.spinner.hide();
        this.selectedItemsSettlement = [];

        // Nuevo modal de respuesta
        // this.modal.show('settlementResponse', { title: 'Respuesta de radicación' });

        Swal.fire({
          type: "success",
          title: "Radicación",
          text: `${createBackingResponse.message} \nal título ${this.createBackingRequest.transactionsToBackUp[0].draftNumber}.`,
          allowOutsideClick: false,
        }).then(() => {
          this.modal.close();
          this.getTransactionsToBackUp(1);
        });
      },
      (error: any) => {
        this.handleCreateBackingError(error);
      }
    );
  }

  handleGetTransactionsToBackUpError(error?: any) {
    console.error(error);
    if (this.showModalOnError === false) {
      if (
        error &&
        error.error &&
        error.error.message &&
        this.counterRequest > 1
      ) {
        const { message } = error.error;
        Swal.fire({
          type: "error",
          title: "Radicación",
          text: `${message}`,
          allowOutsideClick: false,
        });
      } else if (this.counterRequest > 1) {
        this.helper.handleUndefinedError();
      }
    }
    this.createBackingRequest.transactionsToBackUp = [];
    this.transactionsToBackup = [];
    this.selectedItemsSettlement = [];

    this.cantPages = 0;
    this.handleResetPagination();
    this.spinner.hide();
  }

  handleCreateBackingError(error?: any) {
    console.error(error);
    this.getTransactionsToBackUp(1);
    if (error && error.error && error.error.message) {
      const { message } = error.error;
      Swal.fire({
        type: "error",
        title: "Crear respaldos",
        text: `${message}`,
        allowOutsideClick: false,
      });
    } else {
      this.helper.handleUndefinedError();
    }
    this.selectedItemsSettlement = [];
    this.handleResetPagination();
    this.spinner.hide();
  }

  handleResetPagination() {
    if (this.paginationComponent) {
      this.paginationComponent.reset();
    }
  }

  initilizeDateRangePicker() {
    this.search.initialDate = moment(this.initDate)
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .subtract(150, "days")
      .format("YYYY-MM-DD HH:mm:ss");

    this.search.finalDate = moment(this.finalDate)
      .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
      .format("YYYY-MM-DD HH:mm:ss");
  }

  handleSelectedDate($event: any) {
    if ($event[0]) {
      this.search.initialDate = $event[0].format("YYYY-MM-DD HH:mm:ss");
    }
    if ($event[1]) {
      this.search.finalDate = $event[1].format("YYYY-MM-DD HH:mm:ss");
    }
    if (
      $event[1] !== this.search.finalDate ||
      $event[0] !== this.search.initialDate
    ) {
      this.getTransactionsToBackUp(1);
    }
  }

  clearSearch($event) {
    this.transactionsToBackup = [];
    this.backupsStore.changeStateAffiliate(new AffiliatesListModel());
    console.log("clear search on cont");
  }

  validateAffiliate() {
    const { affiliateDocument, issuerDocument } = this.search;
    console.log("validate =>", affiliateDocument, issuerDocument);
    if (
      (affiliateDocument && affiliateDocument !== "0") ||
      (issuerDocument && issuerDocument !== "0")
    ) {
      return true;
    }
    this.helper.showToastMessage(
      "warning",
      "Debe seleccionar un afiliado o comprador",
      ""
    );
    return false;
  }

  filterChangeEvent($event) {
    console.log($event);
    if ($event === undefined) {
      this.search.issuerDocument = "0";
      this.search.issuerDocumentType = "0";
      this.getTransactionsToBackUp(1);
      return;
    }

    if ($event["patternValid"] == false && $event.document !== "") return;

    this.search.issuerDocument = $event.document || "0";
    this.search.issuerDocumentType =
      $event.document == "0" || $event.document == ""
        ? "0"
        : $event.documentType;

    this.getTransactionsToBackUp(1);
  }

  handleCheckLimitDate(date: Date): boolean {
    const actualDate = moment(new Date()).format("YYYY-MM-DD");
    const dateLimitClaim = moment(date).add(1, "day").format("YYYY-MM-DD"); // Se añade un dia para que entre en la validacion de isBetween
    const bLimitDateClaim = moment(date).subtract(11, "days").format("YYYY-MM-DD"); // Para que el dia 10 sea valido por isBetweem se suma uno mas

    if (moment(actualDate).isBetween(bLimitDateClaim, dateLimitClaim)) return false;
    return true;
  }

  alertErrorLimitDate(time) {
    if (this.handleCheckLimitDate(time) === true) {
      this.modal.show("limitDate");
    }
  }
}
